import(/* webpackMode: "eager" */ "/app/src/app/assistant/[assistantId]/error.tsx");
